import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import copyToClipboard from 'copy-to-clipboard';

import Toggle from '../../Toggle';
import Button from '../../Button';

import getErrorMessage from './ErrorMessages';
import OverlayStyles from '../OverlayStyles';

const ErrorOverlay = (props) => {
  const copyText = () => {
    copyToClipboard(JSON.stringify(
      {
        cdf: props.error.cdf,
        trace: props.error.trace,
      }, null, 2
    ));
  };
  return (
    <Overlay>
      <Div>
        <h1>Could not generate chart</h1>
        <p>{getErrorMessage(props.error.code)}</p>
        <Toggle expandText="See full error">
          Error:
          <pre>{props.error.trace}</pre>
          CDF:
          <pre>{JSON.stringify(props.error.cdf, null, 2)}</pre>
          <Button onClick={copyText}>Copy error text</Button>
        </Toggle>
      </Div>
    </Overlay>
  );
};

const Overlay = styled.div`
  ${OverlayStyles}
  width: 100%;
  height: 100%;
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 100px;
    width: 100px;
    transform: translateX(-50%) translateY(-50%);
  }
`;

const Div = styled.div`
  width: 60%;
  position: absolute;
  left: 50%;
  top: 20%;
  transform: translateX(-50%);
  box-shadow: 0px 0px 12px 0px ${(props) => props.theme.brandPurple};
  background-color: #fff;
  padding: 20px 30px;
  h1, p{
    text-align: center;
    font-size: 20px;
    text-transform: uppercase;
  }
  h1{
    color: ${(props) => props.theme.danger};
  }
  p{
    color: #666;
  }
  // Wrapper from Button component
  [class*="Wrapper"]{
    text-align: center;
  }
`;

ErrorOverlay.propTypes = {
  error: PropTypes.object.isRequired,
};

export default ErrorOverlay;



// WEBPACK FOOTER //
// ./app/components/Chart/Errors/ErrorOverlay.js